"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileNameFromPath = exports.formatFileSize = exports.replaceExt = exports.getFileNameWithoutExt = exports.getExt = void 0;

var _path = _interopRequireDefault(require("path"));

var _filesize = _interopRequireDefault(require("filesize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-core.utils.file
 */

/**
 * @description
 * get file extension
 *
 * @Function
 * @name skybase-core.utils.file#getExt
 * @param {String} filename filename
 * @returns {String} file extension
 */
var getExt = function getExt(filename) {
  return _path.default.extname(filename).replace(/^\./, '');
};
/**
 * @description
 * Returns name of file without extension.
 *
 * @param {String}  filename
 */


exports.getExt = getExt;

var getFileNameWithoutExt = function getFileNameWithoutExt(filename) {
  var extension = getExt(filename);
  var matcher = new RegExp(".".concat(extension, "$"));
  return filename.replace(matcher, '');
};
/**
 * @description
 * replace file extension with provided one
 *
 * @Function
 * @name skybase-core.utils.file#replaceExt
 * @param {String} filename filename
 * @param {String} extension new extension for the file
 * @returns {String} filename with new file extension
 */


exports.getFileNameWithoutExt = getFileNameWithoutExt;

var replaceExt = function replaceExt(filename, ext) {
  var parts = filename.split('.');

  if (parts.length < 2) {
    return filename;
  }

  return parts.slice(0, -1).concat(ext).join('.');
};
/**
 * @description
 * formats file size to human readable format
 *
 * @Function
 * @name skybase-core.utils.file#formatFileSize
 * @param {String} number number to format
 * @param {Object} options options object passed to filesize library
 * @returns {String} formatted file size
 */


exports.replaceExt = replaceExt;

var formatFileSize = function formatFileSize(n, options) {
  return !isNaN(n) ? (0, _filesize.default)(n, options) : '';
};

exports.formatFileSize = formatFileSize;

var getFileNameFromPath = function getFileNameFromPath(path) {
  return _path.default.basename(path);
};

exports.getFileNameFromPath = getFileNameFromPath;
//# sourceMappingURL=file.js.map